export default __webpack_public_path__ + "a2925d2b56e7bceff9223b0569bc1d37.svg";